import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { getConference } from '../../../data/conferences';
import PrompterPage from './PrompterPage';

/**
 * `/conference/:conferenceId/prompteur` — le second onglet.
 *
 * Volontairement une route à part et non un panneau du diaporama : le
 * présentateur a un écran de retour (ou une tablette) qui n'est pas celui que
 * la salle voit. Une fenêtre dans le diaporama serait projetée avec lui.
 */
const PrompterRoute = () => {
    const { conferenceId } = useParams();
    const conference = getConference(conferenceId);
    // `?salle=repetition` : en répétition, le compteur lit la session de test
    // et non celle du jour J.
    const [params] = useSearchParams();
    const salle = conference.salle ? (params.get('salle') || conference.salle) : null;

    if (!conference.conducteur) {
        return (
            <div className="w-full h-screen bg-white text-slate-700 flex items-center justify-center p-10">
                <div className="max-w-xl text-center">
                    <h1 className="text-2xl font-bold text-amber-700 mb-3">Pas de conducteur</h1>
                    <p>
                        La conférence « {conference.title} » n'a pas de texte parlé enregistré.
                        Ajoutez un champ <code className="px-1 bg-slate-100 border border-slate-200 rounded">conducteur</code> à
                        son entrée dans <code className="px-1 bg-slate-100 border border-slate-200 rounded">src/data/conferences/index.js</code>.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <PrompterPage
            key={conference.id}
            slides={conference.slides}
            conferenceId={conference.id}
            chemin={conference.conducteur}
            salle={salle}
        />
    );
};

export default PrompterRoute;
